import React from "react";
import "./style.css"

const PrivacyPolicyComponent = () => {
    return (
        <div className="div-body">
            <h1>Senspark's games Privacy Policy</h1>
            <h2>Effective Date: October 08, 2025</h2>
            <p>
                Welcome to Senspark and thanks for playing our games! We respect your privacy rights and recognize the
                importance of protecting the information collected about you. This Privacy Policy is designed to provide
                clarity
                about the information we collect, how we use it to provide a better gaming experience as well as how you
                can
                exercise your privacy rights. This Privacy Policy applies whenever you play our games or otherwise
                access any of
                our other products, services, content, websites and/or the other domains provided by us, together
                referred to as
                "Services." In this policy, "Senspark" refers to Senspark and its "Affiliates", which shall mean
                subsidiaries, parent companies, joint ventures and other corporate entities under common ownership. We
                may also
                refer to Senspark as "we" or "us". If you have any questions regarding our privacy policy or Senspark'
                data protection practices, please contact us as described in the Section 10 ("Contact Us").
                <br/>
                By using the Services, you agree to the collection, disclosure, storage and use of your information as
                outlined
                in this Privacy Policy. If you do not want us to collect, store, use or share your information in the
                ways
                described in this Privacy Policy, you should not play our games or use our Services. We may amend the
                Privacy
                Policy from time to time, and we encourage you to consult the Privacy Policy regularly for changes.
            </p>
            <p>
                <h2>Table of Contents</h2>
                <ol>
                    <li>Information We Collect and Process</li>
                    <li>Purposes of Collecting, Processing and/or Disclosing</li>
                    <li>Sharing of Your Information</li>
                    <li>How to Exercise Your Rights</li>
                    <li>Data Deletion</li>
                    <li>In-app purchases</li>
                    <li>Age Limit</li>
                    <li>Privacy Policies of Linked Sites and Advertisers</li>
                    <li>Security of Your Information</li>
                    <li>Changes to This Privacy Policy</li>
                    <li>Contact Us</li>
                </ol>
            </p>
            <p>
                <h3>1. Information We Collect and Process</h3>
                We only collects and processes your information to the extent necessary to fulfil one or more of its
                functions
                and activities, and will do so only by fair and reasonable means.

                The legal basis for collecting and using the information depends on what the information is and the
                context in
                which we collect it.

                The personal information we may collect and process about you through the Services falls into the
                following
                general categories:
            </p>
            <p>
                <h4>1.1. Data that you provide voluntarily</h4>
                which given consent to the processing of your personal data
                <ul>
                    <li>In-game user name and password</li>
                    <li>your email address</li>
                    <li>Profile information (such as name, social networking sites accounts)</li>
                    <li>Your messages to the Service (such as your reviews and player support tickets)</li>
                    <li>Any other information you choose to give our customer service or other team in the game or via
                        email (such
                        as information to identify a lost account)
                    </li>
                </ul>
            </p>
            <p>
                <h4>1.2 Information We Collect automatically</h4>
                When you access our websites or play our games, we may also collect certain information automatically
                from you
                and/or your device in order to efficiently fulfilling our contractual obligations, better understand our
                users
                and be able to improve our services and your user experience, such as:
                <ul>
                    <li>your mobile device's identifiers</li>
                    <li>details about the games and platforms you use</li>
                    <li>IP address , which only allows us to determine the geographic area and does not reveal your
                        precise
                        location;
                    </li>
                    <li>your device information (such as device type, device system language, network and carrier data,
                        operating
                        system)
                    </li>
                    <li>information regarding your use of and interaction with our Services(such as in-game event, game
                        version)
                    </li>
                    <li>your country</li>
                    <li>application performance and de-bugging information</li>
                    <li>what your current progress is in our Services and the date and time of activity</li>
                    <li>your payment information in our Services</li>
                </ul>
            </p>
            <p>
                <h4>1.3 Information we obtain from third party sources</h4>
                When you use any of Senspark Services via your social media account, such as Facebook, Wechat or Google
                (where
                our games may also be referred to as "applications"), you allow Senspark to access certain information
                from your
                profile on that site to efficiently fulfill our contractual obligations. The information we receive from
                you
                will depend on your social media privacy settings. You can control and find out more about these
                settings at the
                social network services where you play our games. Senspark may access and store some or all of the
                following
                basic information, such as:

                <ul>
                    <li>your user identification number (like your Facebook ID number), which may be linked to
                        publicly-available
                        information like your name and profile photo
                    </li>
                    <li>information about your activities on or through the connected third-party platform</li>
                    <li>any other information that you or the third-party platform share with us</li>
                </ul>

                We may collect information about you from third-party sources, such as advertising partners. We may get
                your
                personal information, for example, if you clicked on an advertisement directing you to one of our
                Services, we will
                be provided with information about which advertising network and advertising campaign the install
                originated from.
            </p>
            <p>
                <h4>1.4 Health Data</h4>
                We may collect and process the following health-related data from your device:

                <ul>
                    <li><b>Walking Steps Data:</b> We collect your daily walking step count to enable in-game features where you can complete tasks and receive rewards based on your physical activity progress.</li>
                </ul>

                <b>Important Information About Health Data:</b>
                <ul>
                    <li>We only collect walking steps data. We do not collect any other health or fitness data such as heart rate, sleep data, body measurements, or other health metrics.</li>
                    <li>This data is used solely for in-game mechanics and reward systems.</li>
                    <li>Walking steps data is processed internally within the game and is NOT shared with any third parties, including advertisers or analytics providers.</li>
                    <li>You can revoke access to your walking steps data at any time through your device's health data permissions settings.</li>
                </ul>
            </p>
            <p>
                <h3>2. Purposes of Collecting, Processing and/or Disclosing:</h3>
                <ul>
                    <li>Detecting/Protecting against security events</li>
                    <li>Customer service</li>
                    <li>Operate our business and games</li>
                    <li>Game mechanics or functionality</li>
                    <li>Facilitate players social interactions</li>
                    <li>Product development/improvement</li>
                    <li>Maintaining and enhancing service</li>
                    <li>Advertising</li>
                    <li>Player acquisition</li>
                    <li>Process walking steps data for in-game task completion and reward distribution</li>
                </ul>
            </p>
            <p>
                <h3>3. Sharing of Your Information</h3>
                We will share your personal information with third parties only in the ways that are described in this
                Privacy
                Policy. We do not sell your personal information to third parties. We may, however, share non-personally
                identifiable, aggregated, and/or public information with third parties. Additionally, we may share your
                game
                play data, customer service and/or unique identifiers specific to your device with third parties for the
                purpose
                of personalizing, adjusting and improving our Services. We direct all such third party service providers
                to
                maintain the confidentiality of the information disclosed to them and not to use your information for
                any
                purpose other than to provide services on Senspark behalf.

                We may have advertising on our Service. When advertisers or advertise intermediaries place ads in our
                Service,
                they may collect, or we may collect and share with them the following types of information from within
                our
                Service:

                <ul>
                    <li>performance data (like the number of clicks on an advertisement);</li>
                    <li>aggregated and/or de-identified information about players;</li>
                    <li>certain technical information (for example, IP addresses, non-persistent device identifiers such
                        as IDFAs,
                        and device identifiers);
                    </li>
                    <li>your social network ID.</li>
                </ul>

                The information collected may be used to:
                <ul>
                    <li>measure how effective ads are;</li>
                    <li>personalize the player experience by showing advertisements for products and services that may
                        be more
                        likely to appeal to you;
                    </li>
                    <li>undertake web analytics to analyze traffic and other player activity.</li>
                </ul>

                <b>Health Data Sharing:</b> We do not share your walking steps data or any other health-related information with third parties. This data remains within the game and is used exclusively for in-game features as described in Section 1.4.
                <br/><br/>
                Furthermore, we share your Device identifiers to advertising network companies for the purpose of them
                serving
                behavioral advertisements to you within the App. We use or may use the following advertising network
                companies:
                <ul>
                    <li><a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener noreferrer">Apple
                        EULA</a></li>
                    <li><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google
                        Play Services</a></li>
                    <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Google
                        Analytics for Firebase</a></li>
                    <li><a href="https://firebase.google.com/support/privacy/" target="_blank"
                           rel="noopener noreferrer">Firebase Crashlytics</a></li>
                    <li><a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank"
                           rel="noopener noreferrer">AdMob</a></li>
                    <li><a href="https://www.facebook.com/about/privacy/update/printable" target="_blank"
                           rel="noopener noreferrer">Facebook</a></li>
                    <li><a href="https://unity3d.com/legal/privacy-policy" target="_blank"
                           rel="noopener noreferrer">Unity</a></li>
                    <li><a href="https://www.applovin.com/privacy/" target="_blank"
                           rel="noopener noreferrer">AppLovin</a></li>
                    <li><a href="https://vungle.com/privacy/" target="_blank" rel="noopener noreferrer">Vungle</a></li>
                    <li><a href="https://www.adcolony.com/privacy-policy/" target="_blank"
                           rel="noopener noreferrer">AdColony</a></li>
                    <li><a href="https://www.appsflyer.com/legal/privacy-policy/" target="_blank"
                           rel="noopener noreferrer">AppsFlyer</a></li>
                    <li><a href="https://www.costcenter.net/privacy-policy" target="_blank" rel="noopener noreferrer">Cost
                        Center</a></li>
                </ul>
                The recipients use of the disclosed information will not be covered by this Privacy Policy. If you have
                questions
                concerning the processing carried out by such third parties, you should review their privacy policy.
            </p>
            <p>
                <h3>4. How to Exercise Your Rights</h3>
                You may access, amend and delete information provided by you when using our Services, or contact us. The
                scope
                and the way in which you access, amend or delete your personal information
                depend on the service you use. For iOS users, you can request the deletion of your account from within
                the app.
                <br/>
                You may opt-out of receiving promotional communications, such as marketing emails we send you, at any
                time. If
                you wish to do so, please e-mail us. You can turn off push notifications by visiting
                the "options" or "settings" page within the relevant games.
                <br/>
                You can opt-out of interest-based advertising on mobile applications by checking the privacy settings of
                your
                Android or iOS device and selecting "limit ad tracking" (Apple iOS) or "opt-out of interest based ads"
                (Android). For personalized in-game offers opt-out, you can use the options provided in the game
                settings.
                <br/>
                If for any reason you are concerned with the way we are using your personal information, or would like
                to
                correct or request that we delete such personal information, please contact Senspark using the
                information
                in the "Contact Us" section below. We will respond to your request as promptly as possible.
                <br/>
                In some cases, we may not be able to delete your personal information and will retain and use our
                information as
                long as necessary to comply with our legal obligations, resolve disputes, and/or enforce our agreements.
            </p>
            <p>
                <h3>5. Data Deletion</h3>
                We will delete or de-identify your personal data as reasonably possible in the following cases:
                <ul>
                    <li>When we have no ongoing legitimate business need to process your personal information;</li>
                    <li>When we stop operating our Service;</li>
                    <li>When you request your data to be deleted;</li>
                    <li>When a platform, such as Meta requires the deletion of your Open Platform Data at their
                        discretion, either
                        to protect you or as part of their compliance review;
                    </li>
                    <li>When required by applicable law or regulation.</li>
                </ul>

                We retain personal information we collect from you where we have an ongoing legitimate business need to
                do so, when
                we operate our Service and when we ensure that your personal data is subject to suitable safeguards. For
                example, to
                provide you with a Service you have requested, or to comply with applicable legal, tax or accounting
                requirements.
                We will for example periodically de-identify unused game accounts and we regularly review and delete
                unnecessary
                data.
            </p>
            <p>
                <h3>6. In-app purchases</h3>
                <h4>6.1. In-game Virtual Currency and Virtual Items</h4>
                The Service may include an opportunity for you to earn, buy or otherwise obtain in-game currency
                ("Virtual Currency") to access virtual, in-game digital goods or items ("Virtual Items"). Methods of
                obtaining Virtual Currency are at Senspark's sole discretion. Virtual Currency and Virtual Items are not
                real currency, do not have monetary value, and may not be redeemed for legal currency, or items of value
                outside of the Services.
                <br/>
                Virtual Currency and Virtual Items obtained via the Service are provided to you under a limited,
                personal, revocable, non-transferable, non-sublicenseable license to use within the Service. You have no
                property interest, right or title in or to any Virtual Currency or Virtual Items appearing or
                originating in the Service, and they may not be transferred or resold in any manner, including, without
                limitation, by means of any direct sale or auction service.
                <br/>
                Senspark has no liability for hacking or loss of your Virtual Currency or Virtual Items or any goods or
                services obtained via Virtual Currency. Senspark has no obligation to, and will not, reimburse you for
                any Virtual Currency or Virtual Items obtained via Virtual Currency. Senspark reserves the right, in its
                sole discretion and without prior notification, to change or limit the price, availability, or order
                quantity of any Virtual Currency or Virtual Items and to refuse to provide you with any Virtual Currency
                or Virtual Items.
                <br/>
                Virtual Currency may have an expiration date. If your Virtual Currency or Virtual Items expire and you
                still have an active Account, Senspark may offer conversion of such Virtual Currency into Virtual Items
                for you in its sole discretion, however Senspark is under no obligation to do so. Virtual Currency and
                Virtual Items may be forfeited if:
                <ul>
                    <li>(a) your Account or access to the Services is terminated or suspended for any reason;</li>
                    <li>(b) you breach these Terms;</li>
                    <li>(c) Senspark discontinues availability of the Service; or</li>
                    <li>(d) you disassociate from the Service.</li>
                </ul>
                <h4>6.2. Subscriptions</h4>
                In some of our games, you may pay a fee for a subscription membership ("Subscription").
                <br/>
                When you buy a Subscription, you agree to the following:
                <ul>
                    <li>A Subscription fee will be charged to your chosen payment method in the app store of your
                        device's platform ("App Store"). You will be charged the Subscription fee displayed at the time
                        of sale;
                        and
                    </li>
                    <li>Your Subscription will automatically renew for the applicable length of your Subscription until
                        either you or Senspark cancels your Subscription. By way of example, if you buy a 3-month
                        Subscription,
                        the Subscription will automatically renew for another 3-month period (unless either you or
                        Senspark
                        cancels your Subscription).
                    </li>
                </ul>

                <br/>
                <u>Canceling Subscriptions:</u>
                <br/>
                To stop automatic renewal of your Subscription and automatic withdrawal of Subscription fees, you must
                cancel your Subscription within 24 hours before it renews for the length of the next Subscription
                period. You may cancel your Subscription at any time by managing the subscription settings at your App
                Store.
                <br/><br/>
                For the Google Play store, instructions for canceling your Subscription may be found here:
                <br/>
                <a href="https://support.google.com/googleplay/answer/7018481">https://support.google.com/googleplay/answer/7018481</a>
                <br/>
                For the Apple App store, instructions for canceling your Subscription may be found here:
                <br/>
                <a href="https://support.apple.com/en-us/HT202039">https://support.apple.com/en-us/HT202039</a>

                <br/><br/>
                <u>Other Subscription Terms:</u>
                <br/>
                To receive any daily rewards as part of your Subscription, you must open the game that you have the
                Subscription for. You will not receive rewards for the days on which you did not open the game.

                <br/><br/>
                <h4>6.3. Payments for Subscriptions, Virtual Currencies, and Virtual Items</h4>
                <br/>
                When you pay for a Subscription, Virtual Currencies, and/or Virtual Items, all payments are charged and
                processed by the App Store (e.g. the Google Play store or the Apple App store), so please review your
                app store's payment terms for additional payment terms that may apply.
                <br/>
                You agree that all payments for Virtual Currency, Virtual Items, and Subscriptions are final. No refunds
                will be given, except in Senspark's sole and absolute discretion.
            </p>
            <p>
                <h3>7. Age Limit </h3>
                When we collect personal information, we do not know the age of our players. If a player has a social
                media
                account and has logged into a game, we may obtain the age information from the player through that. If
                we learn
                that we have collected personal data about a child under age 13, we will take reasonable steps to delete
                such
                data as promptly as possible. If you are a minor under 16 years old, please note that you are allowed to
                use our
                Services upon the prior consent of your parents or legal guardian.
            </p>
            <p>
                <h3>8. Privacy Policies of Linked Sites and Advertisers </h3>
                Our websites and games may contain advertisements from companies other than Senspark that may link to
                their own
                websites. We are not responsible for the privacy practices or the content of such websites. If you have
                any
                questions about how these other websites use your information, you should review their policies and
                contact them
                directly.
            </p>
            <p>
                <h3>9. Security of Your Information </h3>
                We value your trust in providing us your Personal Information, thus we are striving to use commercially
                acceptable
                means of protecting it. But remember that no method of transmission over the internet, or method of
                electronic
                storage is 100% secure and reliable, and we cannot guarantee its absolute security.
            </p>
            <p>
                <h3>10. Changes to This Privacy Policy </h3>
                We may update our Privacy Policy from time to time. Thus, you are advised to review this page
                periodically for
                any
                changes. We will notify you of any changes by posting the new Privacy Policy on this page.
                <br/>
                This policy is effective as of 2025-10-08
            </p>
            <p>
                <h3>11. Contact Us</h3>
                If you have any questions or suggestions about our Terms and Conditions, do not hesitate to contact us
                at &nbsp;
                <a href="mailto:contact@senspark.com">contact@senspark.com</a>.
            </p>
        </div>
    );
};

export default PrivacyPolicyComponent